import React from 'react';
import { Form } from '@ant-design/compatible';

import DateSinglePicker from '../../datePicker/DateSinglePicker';
import './DateSingleForm.scss';
import { validDate } from '../../../lib/moment';

const DateSingleForm = (props) => {
  const {
    className,
    label,
    name,
    value,
    outFormat,
    btnTextFormat,
    format,
    form,
    showTimeFormat,
    rules,
    onSelect,
    allowClear,
    required,
  } = props;

  return (
    <div className={className}>
      <Form.Item label={label}>
        {form.getFieldDecorator(name, {
          initialValue: validDate(value) ? value : null,
          rules,
        })(
          <DateSinglePicker
            outFormat={outFormat}
            btnTextFormat={btnTextFormat}
            format={format}
            onSelect={onSelect}
            showTime={showTimeFormat}
            allowClear={allowClear}
            required={required}
          />,
        )}
      </Form.Item>
    </div>
  );
};

export default DateSingleForm;
